'use strict';
angular.module('schoolLinqApp').directive('rcComboCheckBox', function () {
	return {
		require: ['ngModel'],
		scope: {
			labelName: '@',
			options: '=',
			ngModel: '=',
		},
		replace: true,
		restrict: 'E',
		template: require('@ajs/templates/reports/rcComboCheckBox.html'),
		controller: [
			'$scope',
			function ($scope) {
				$scope.ngModel = [];

				$scope.click = function (option) {
					var hasElement = $scope.isSelected(option);
					if (hasElement >= 0) {
						$scope.ngModel.splice(hasElement, 1);
					} else {
						$scope.ngModel.push(option);
					}
				};

				$scope.isSelected = function (option) {
					return _.findIndex($scope.ngModel, function (op) {
						return op === option;
					});
				};

				$scope.checkAll = function () {
					$scope.ngModel = $scope.options;
				};

				$scope.unSelectAll = function () {
					$scope.ngModel = [];
				};
			},
		],
	};
});
